export type EssayKind = "sop" | "research" | "personal" | "community" | "short";
export type EssayRequirement = {
  id: string;
  kind: EssayKind;
  title: string;
  prompt: string;
  limit: string;
  maxWords: number;
  chinese: string;
  english: string;
  status: "未开始" | "中文初稿" | "英文初稿" | "待复核" | "已定稿";
};
export type ApplicationProgram = {
  id: string;
  school: string;
  name: string;
  track: string;
  cycle: string;
  status: string;
  priority?: string;
  ranking?: string;
  fitReason?: string;
  aiPolicy?: string;
  deadline: string;
  deadlineTime: string;
  timezone: string;
  deadlineNote: string;
  language: string;
  funding: string;
  eligibility: string;
  sourceUrls: string;
  checkedAt: string;
  portalChecked: boolean;
  advisorIds: string[];
  facultyNotes: string;
  notes: string;
  materials: { recommendationsReady: boolean; cvReady: boolean; transcriptReady: boolean; recommendationsSubmitted: boolean; languageSubmitted: boolean };
  essays: EssayRequirement[];
  updatedAt?: string;
};
export const programStatuses = ["候选项目", "准备文书", "待提交", "已提交", "暂停"];
export const essayStatuses: EssayRequirement["status"][] = ["未开始", "中文初稿", "英文初稿", "待复核", "已定稿"];
export function emptyProgram(): ApplicationProgram {
  return { id: "", school: "", name: "", track: "", cycle: "2027 Fall", status: "候选项目", deadline: "", deadlineTime: "", timezone: "", deadlineNote: "", language: "", funding: "", eligibility: "", sourceUrls: "", checkedAt: "", portalChecked: false, advisorIds: [], facultyNotes: "", notes: "", materials: { recommendationsReady: true, cvReady: true, transcriptReady: true, recommendationsSubmitted: false, languageSubmitted: false }, essays: [] };
}
export function newEssay(kind: EssayKind = "sop"): EssayRequirement {
  return { id: crypto.randomUUID(), kind, title: "新文书", prompt: "", limit: "以该项目当年网申要求为准", maxWords: 0, chinese: "", english: "", status: "未开始" };
}
export const englishWords = (value: string) => (value.trim().match(/[A-Za-z0-9]+(?:['’-][A-Za-z0-9]+)*/g) || []).length;
